<div class="nes-mb-0">
  <div class="nes-flex nes-items-start nes-w-full nes-justify-between">
    <div class="nes-flex nes-gap-1">
      <h3 class="nes-h5" style="font-size: 16px;">{{
        "COMPOSE.CHOOSE_EXTRAS.ADDON." + addon.identifier + ".TITLE" | translate
      }}</h3>
    </div>
  </div>

  <div class="addon-description">
    {{
      "COMPOSE.CHOOSE_EXTRAS.ADDON." + addon.identifier + ".DESCRIPTION"
        | translate
    }}
  </div>

  @if (addon.price) {
    <div class="nes-mb-3">
      <nes-price
        [price]="addon.price / 100"
        [size]="$any({ xs: 'base', md: 'xl' })"
        [trailingText]="'COMPOSE.CHOOSE_EXTRAS.PRICE_CATEGORY' | translate"
      >
      </nes-price>
    </div>
  }

  <div class="toggle-group">
    <nes-selectable
      #buttonRefTrue
      class="toggle-btn toggle-btn--left"
      [class.toggle-btn--active]="addon.selected"
      [id]="addon.identifier + '__ButtonTrue'"
      [nesId]="addon.identifier + '__ButtonTrue'"
      [label]="'COMPANY_DATA.TOGGLE_BUTTON.YES' | translate"
      name="option-yes"
      [checked]="addon.selected"
      (nesOnClick)="!routeLoading && !addon.selected && selected.emit(true)"
    >
      <div class="nes-flex nes-items-center nes-justify-center nes-h-full toggle-btn-text">
        {{
          "COMPOSE.CHOOSE_EXTRAS.ADDON." + addon.identifier + ".BUTTON.CONFIRM"
            | translate
        }}
      </div>
    </nes-selectable>

    <nes-selectable
      #buttonRefFalse
      class="toggle-btn toggle-btn--right"
      [class.toggle-btn--active]="!addon.selected"
      [id]="addon.identifier + '__ButtonFalse'"
      [nesId]="addon.identifier + '__ButtonFalse'"
      [label]="'COMPANY_DATA.TOGGLE_BUTTON.NO' | translate"
      name="option-no"
      [checked]="!addon.selected"
      (nesOnClick)="!routeLoading && addon.selected && selected.emit(false)"
    >
      <div class="nes-flex nes-items-center nes-justify-center nes-h-full toggle-btn-text">
        {{
          "COMPOSE.CHOOSE_EXTRAS.ADDON." + addon.identifier + ".BUTTON.DECLINE"
            | translate
        }}
      </div>
    </nes-selectable>
  </div>
</div>
